var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9249_5392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -1,
    width: 10,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7931 14.2916C3.40296 14.6825 3.40284 15.3164 3.79282 15.7075C4.18281 16.0985 4.81523 16.0987 5.20537 15.7078L12.0883 8.81134C12.1293 8.78121 12.1686 8.74755 12.2057 8.71036C12.5869 8.32826 12.5953 7.71448 12.2312 7.32217C12.2202 7.31008 12.2089 7.29819 12.1973 7.28651C12.1891 7.27833 12.1808 7.27032 12.1725 7.26248L5.20546 0.291671C4.81504 -0.0989597 4.18236 -0.0986488 3.79232 0.292366C3.40229 0.68338 3.4026 1.31703 3.79302 1.70766L10.0771 7.99521L3.7931 14.2916Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9249_5392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightFilled);
export default __webpack_public_path__ + "static/media/chevron-right-filled.7ebbf5889bfed7c5088da2ebab3a8754.svg";
export { ForwardRef as ReactComponent };